import React from 'react'
import Template from './template'

const Market = () => <Template type="1" />
const Gas = () => <Template type="2" />
const GasAbnormal = () => <Template type="2" dataType="abnormal" />

export default {
  Market,
  Gas,
  GasAbnormal
}
